import React from 'react';

type Props = {
    children: React.ReactNode
}

function StackedList(props: Props) {
    return (
        <ul className="border border-gray-200 rounded-md divide-y divide-gray-200">
            {props.children}
        </ul>
    );
}

export default StackedList;